import 'shared/styles/gate.css';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchMaterialsRequest } from 'shared/redux/actions/MaterialsActions';
import { io } from 'socket.io-client';
import { Image } from 'react-bootstrap';
import {
  getDestinationsState,
  getMaterialsState,
  getOptionsState,
  getOrderState,
} from '../redux/src/StatesGetter';
import { createOrderRequest } from '../redux/actions/OrderActions';
import socketService from '../services/SocketService';
import LicensePlate from '../services/LicencePlateService';
import Alerts from '../components/Alerts';
import image from '../assets/images/logo_agrewest.png';
import alerts from '../components/Alerts';
import { fetchOptionsRequest } from '../redux/actions/OptionsActions';
import { fetchDestinationsRequest } from '../redux/actions/DestinationsActions';
import ReloadButton from '../components/ReloadButton';

const MainPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMaterial, setSelectedMaterial] = useState();
  const [selectedQuantity, setSelectedQuantity] = useState('max');
  const materials = useSelector(getMaterialsState, shallowEqual);
  const options = useSelector(getOptionsState, shallowEqual);
  const destinations = useSelector(getDestinationsState, shallowEqual);
  const [vehicleData, setVehicleData] = useState({ numberPlate: '', _id: '' });
  const [scaleEventData, setScaleEventData] = useState({ value: 0, state: '' });
  const [orderEventData, setOrderEventData] = useState({ action: '' });
  const [step, setStep] = useState(1);
  const [currentDriver, setCurrentDriver] = useState();
  const [currentDestination, setCurrentDestination] = useState();
  const [currentBuyer, setCurrentBuyer] = useState();
  const [currentTrailer, setCurrentTrailer] = useState('');
  const [alertVisible, setAlertVisible] = useState(false);

  interface EventData {
    action?: string;
    vehicle?: any;
    order?: any;
  }

  const bottomRef = useRef<HTMLDivElement>(null);
  const [eventData, setEventData] = useState<EventData>({});
  const inactivityTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Handle inactivity timeout - reload page after 30 seconds of no activity (only if vehicleData exists and not in final_load state)
  useEffect(() => {
    const resetTimer = () => {
      // Clear existing timer
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }

      // Only set timer if vehicleData exists and action is not 'final_load'
      if (vehicleData?.numberPlate && eventData?.action !== 'final_load') {
        // Set new timer for 30 seconds
        inactivityTimerRef.current = setTimeout(() => {
          window.location.reload();
        }, 30000); // 30 seconds
      }
    };

    // Initial timer start
    resetTimer();

    // Activity events that should reset the timer
    const activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // Cleanup
    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [vehicleData, eventData]);

  useEffect(() => {
    socketService.connect().then(() => {
      console.log('Socket connected!');
      socketService.on('vehicle', (data) => {
        console.log('socketEventData', data);
        setEventData(data);
        if (data?.vehicle) {
          setVehicleData(data?.vehicle);
          dispatch(fetchOptionsRequest({ licencePlate: data.vehicle.numberPlate }));
        }
      });

      socketService.on('scale', (scaleData) => {
        console.log('scaleData', scaleData);
        if (scaleData?.state !== 'idle') {
          setScaleEventData(scaleData);
        }
      });

      socketService.on('order', (orderData) => {
        console.log('orderData', orderData);
        setOrderEventData(orderData);
        {
          orderData.action == 'completed' && handlePrintDocuments();
        }
      });
    });
    return () => {
      console.log('Socket disconnected!');
      socketService.disconnect();
    };
  }, []);

  useEffect(() => {
    dispatch(fetchMaterialsRequest());
  }, []);

  useEffect(() => {
    if (alertVisible) {
      // Your logic when the alert is visible
    }
  }, [alertVisible]);

  useEffect(() => {
    // Auto-select driver if there's only one in the list
    if (options?.drivers && options.drivers.length === 1 && !currentDriver) {
      setCurrentDriver(options.drivers[0].id);
    }
  }, [options?.drivers, currentDriver]);

  useEffect(() => {
    // Auto-select trailer if there's only one in the list
    if (options?.trailers && options.trailers.length === 1 && !currentTrailer) {
      setCurrentTrailer(options.trailers[0]);
    }
  }, [options?.trailers, currentTrailer]);

  useEffect(() => {
    // Auto-select buyer if there's only one in the list
    if (options?.buyers && options.buyers.length === 1 && !currentBuyer) {
      const buyer = options.buyers[0];
      console.log('Auto-selecting buyer:', buyer);
      setCurrentBuyer(buyer.id);
      dispatch(fetchDestinationsRequest({ buyerId: buyer.id }));
    }
  }, [options?.buyers, currentBuyer, dispatch]);

  useEffect(() => {
    // Auto-select destination if there's only one in the list
    if (destinations?.destinations && destinations.destinations.length === 1 && !currentDestination) {
      const destination = destinations.destinations[0];
      console.log('Auto-selecting destination:', destination);
      setCurrentDestination(destination.lDestinatie);
    }
  }, [destinations?.destinations, currentDestination]);

  const handleCurrentDriver = async (driver) => {
    setCurrentDriver(driver.id);
  };

  const handleCurrentDestination = async (destination) => {
    setCurrentDestination(destination.lDestinatie);
  };

  const handlePrintDocuments = async () => {
    alerts.textAlert('Succes', 'Incarcarea a fost finalizata cu succes');
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
      window.location.reload();
    }, 5000);
  };
  const handleCurrentBuyer = async (buyer) => {
    console.log('handleCurrentBuyer called with:', buyer);
    setCurrentBuyer(buyer.id);
    dispatch(fetchDestinationsRequest({ buyerId: buyer.id }));
  };
  const handleCurrentTrailer = async (trailer) => {
    setCurrentTrailer(trailer);
  };

  const handleNextStep = async (step, current) => {
    if (!current) {
      alerts.errorAlert('Va rugam selectati o optiune');
      return;
    }

    setStep(step);
  };

  const handleOrderClick = async () => {
    if (!selectedMaterial) {
      alerts.errorAlert('Va rugam selectati o optiune');
      return;
    }
    setStep(5);

    dispatch(
      createOrderRequest({
        quantity: 0,
        fullLoad: true,
        vehicle: vehicleData._id,
        driverId: currentDriver,
        buyerId: currentBuyer,
        productId: selectedMaterial,
        destinationId: currentDestination,
        trailerLicensePlate: currentTrailer,
      }),
    );
  };

  const handleReload = () => {
    // Always reset form state to step 1, preserving vehicleData and eventData.action
    // Only do a full page reload if we have absolutely no data
    const hasVehicleData = vehicleData?.numberPlate && vehicleData.numberPlate.trim() !== '';
    const hasAction = eventData?.action && eventData.action.trim() !== '';
    const hasAnyState = hasVehicleData || hasAction || currentDriver || currentBuyer || selectedMaterial;

    console.log('handleReload - vehicleData:', vehicleData, 'hasVehicleData:', hasVehicleData, 'hasAction:', hasAction, 'hasAnyState:', hasAnyState);

    // If we have any state indicating we're in a flow, reset form but keep vehicleData
    if (hasAnyState || hasVehicleData || hasAction) {
      console.log('Resetting form state but keeping vehicleData and action');
      // Reset form state to step 1
      setStep(1);
      setCurrentDriver(undefined);
      setCurrentBuyer(undefined);
      setCurrentTrailer('');
      setCurrentDestination(undefined);
      setSelectedMaterial(undefined);
      setScaleEventData({ value: 0, state: '' });
      setOrderEventData({ action: '' });
      setAlertVisible(false);

      // Preserve vehicleData - it should remain unchanged
      // Preserve eventData.action so the form continues to show
      if (eventData?.action) {
        setEventData({
          action: eventData.action,
          ...(eventData.vehicle ? { vehicle: eventData.vehicle } : {}),
        });
      }

      // Re-fetch options for the current license plate if we have one
      if (hasVehicleData) {
        dispatch(fetchOptionsRequest({ licencePlate: vehicleData.numberPlate }));
      }
    } else {
      // Only reload if we truly have nothing
      console.log('No state found, doing full page reload');
      window.location.reload();
    }
  };

  console.log('vehicleData', vehicleData);
  console.log('Event data:', eventData);
  console.log('orderEventData:', orderEventData);
  console.log('materials:', materials);
  console.log('destinations:', destinations.destinations);
  return (
    <div className="gate-page" style={!vehicleData.numberPlate ? { height: '100vh', overflow: 'hidden' } : {}}>
      <main style={!vehicleData.numberPlate ? { height: '100%', overflow: 'hidden' } : {}}>
        <div className="container-fluid p-0" style={!vehicleData.numberPlate ? { height: '100%' } : {}}>
          <section style={!vehicleData.numberPlate ? { height: '100%' } : {}}>
            <div className="container" style={!vehicleData.numberPlate ? { height: '100%' } : {}}>
              <div className="row justify-content-end" style={!vehicleData.numberPlate ? { height: '100%', margin: 0 } : {}}>
                <div className="col-lg-12 col-xl-12 col-md-12 col-12" style={!vehicleData.numberPlate ? { height: '100%', padding: 0 } : {}}>
                  {eventData?.action !== 'final_load' && <ReloadButton onClick={handleReload} />}
                  {!vehicleData.numberPlate && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        padding: '40px 20px',
                        fontSize: 90,
                        textAlign: 'center',
                        boxSizing: 'border-box',
                      }}
                    >
                      Numar de inmatriculare neidentificabil
                    </div>
                  )}
                  {vehicleData.numberPlate && (
                    <>
                      <div className="orderForm">
                        <div className="title">Foaie de comandă</div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginRight: 40,
                          }}
                        >
                          <div>
                            <LicensePlate licenceNumber={vehicleData?.numberPlate} />
                          </div>
                          <div>
                            <div>
                              <strong>Tara:</strong>{' '}
                              {eventData?.order
                                ? eventData?.order?.weightOnArrival / 1000
                                : scaleEventData?.value / 1000}{' '}
                              t
                            </div>
                          </div>
                        </div>
                        {eventData?.action === 'final_load' && (
                          <>
                            <div>
                              <strong>Sort comandat:</strong>{' '}
                              {eventData?.order?.material || 'Not Assigned'}
                            </div>
                            <div className="finalLoad">
                              <div className="finalLoadItem">
                                <div className="finalLoadTitle">ÎNCĂRCARE PRIMARĂ</div>
                                <div className="finalLoadValue">
                                  {eventData?.order?.quantity / 1000} t
                                </div>
                              </div>

                              <div className="finalLoadItem">
                                <div className="finalLoadTitle">DE SUPLIMENTAT</div>
                                <div className="finalLoadValue">
                                  {(eventData?.order?.maxWeight - scaleEventData.value) / 1000} t{' '}
                                </div>
                              </div>
                            </div>
                            <div className="finalLoadTitle">CANTITATE INCARCATĂ</div>
                            <div className="finalLoadValue">{scaleEventData?.value / 1000} t</div>
                          </>
                        )}

                        {eventData?.action === 'initial_load' && step === 1 && (
                          <>
                            <div className="title" style={{ textAlign: 'center' }}>
                              Sunt soferul{' '}
                            </div>
                            <div className="listDisplay">
                              {options?.drivers?.map((driver, index) => (
                                <>
                                  <button
                                    className={`quantityButton ${
                                      currentDriver === driver.id ? 'active' : ''
                                    }`}
                                    onClick={() => {
                                      handleCurrentDriver(driver);
                                    }}
                                  >
                                    <div>
                                      <div>{driver.value}</div>
                                    </div>
                                  </button>
                                </>
                              ))}
                            </div>
                            <div ref={bottomRef} className="buttonContainer">
                              <button
                                className="placeOrderButton"
                                onClick={() => {
                                  handleNextStep(2, currentDriver);
                                }}
                              >
                                CONTINUA
                              </button>
                            </div>
                          </>
                        )}

                        {eventData?.action === 'initial_load' && step === 2 && (
                          <>
                            <div className="title" style={{ textAlign: 'center' }}>
                              Numar remorca
                            </div>
                            <div className="listDisplay">
                              {options?.trailers?.map((trailer, index) => (
                                <>
                                  <button
                                    className={`quantityButton ${
                                      currentTrailer === trailer ? 'active' : ''
                                    }`}
                                    onClick={() => {
                                      handleCurrentTrailer(trailer);
                                    }}
                                  >
                                    <div>
                                      <div>{trailer}</div>
                                    </div>
                                  </button>
                                </>
                              ))}
                            </div>
                            <div ref={bottomRef} className="buttonContainer">
                              <button className="formButton" onClick={() => setStep(1)}>
                                Inapoi
                              </button>
                              <button
                                className="formButton"
                                onClick={() => handleNextStep(3, currentTrailer)}
                              >
                                CONTINUA
                              </button>
                            </div>
                          </>
                        )}

                        {eventData?.action === 'initial_load' && step === 3 && (
                          <>
                            <div className="title" style={{ textAlign: 'center' }}>
                              Cumpar pentru
                            </div>
                            <div className="listDisplay">
                              {options?.buyers?.map((buyer, index) => (
                                <>
                                  <button
                                    className={`quantityButton ${
                                      currentBuyer === buyer.id ? 'active' : ''
                                    }`}
                                    onClick={() => {
                                      handleCurrentBuyer(buyer);
                                    }}
                                  >
                                    <div>
                                      <div>{buyer.value}</div>
                                    </div>
                                  </button>
                                </>
                              ))}
                            </div>
                            <div ref={bottomRef} className="buttonContainer">
                              <button className="formButton" onClick={() => setStep(2)}>
                                Inapoi
                              </button>
                              <button
                                className="formButton"
                                onClick={() => handleNextStep(4, currentBuyer)}
                              >
                                CONTINUA
                              </button>
                            </div>
                          </>
                        )}

                        {eventData?.action === 'initial_load' && step === 4 && (
                          <>
                            <div className="title" style={{ textAlign: 'center' }}>
                              Destinatia
                            </div>
                            <div className="listDisplay">
                              {destinations.destinations?.map((destination, index) => (
                                <>
                                  <button
                                    className={`quantityButton ${
                                      currentDestination === destination.lDestinatie ? 'active' : ''
                                    }`}
                                    onClick={() => {
                                      handleCurrentDestination(destination);
                                    }}
                                  >
                                    <div>
                                      <div>{destination.denumireLocalitateDescarcare}</div>
                                      {/* <div>{material.size}</div> */}
                                    </div>
                                  </button>
                                </>
                              ))}
                            </div>
                            <div ref={bottomRef} className="buttonContainer">
                              <button className="formButton" onClick={() => setStep(3)}>
                                Inapoi
                              </button>
                              <button
                                className="formButton"
                                onClick={() => handleNextStep(5, currentBuyer)}
                              >
                                CONTINUA
                              </button>
                            </div>
                          </>
                        )}

                        {eventData?.action === 'initial_load' && step === 5 && (
                          <>
                            <div className="title" style={{ textAlign: 'center' }}>
                              Vreau sa comand
                            </div>
                            <div className="listDisplay">
                              {materials?.map((material, index) => (
                                <>
                                  <button
                                    className={`quantityButton ${
                                      selectedMaterial === material.internalId ? 'active' : ''
                                    }`}
                                    onClick={() => {
                                      setSelectedMaterial(material.internalId);
                                    }}
                                  >
                                    <div>
                                      <div>{material.name}</div>
                                      <div>{material.size}</div>
                                    </div>
                                  </button>
                                </>
                              ))}
                            </div>
                            <div ref={bottomRef} className="buttonContainer">
                              <button className="formButton" onClick={() => setStep(4)}>
                                Inapoi
                              </button>
                              <button className="formButton" onClick={() => handleOrderClick()}>
                                PLASARE COMANDĂ
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};

export default MainPage;
